import fetch from '../../utils/fetch'
// import {
	
// 	encryptWithAes,
// 	generateAesKey,
	
// } from '@/utils/crypto';
// const aesKey = generateAesKey();
import keyList from '@/config/key.json';
export function getBasicConfig(id) {

    
    return fetch({
        url: '/api/area/config/' + id,
        method: 'GET',
    })
}
// export function getwebApiBasicConfig(parkinglotId,areaId) {
//     let params = {
//         parkinglotId:parkinglotId,
//         areaId:areaId,
//         appId:keyList.Area_Info_App_Id,
//         // merId:"10002211252",
//     }
//     return fetch({
//         url: `/webApi/encrypt/area/info?body=`+encryptWithAes(JSON.stringify(params), aesKey),
//         method: 'GET',
//         isEncrypt:true,
//     })
// }

export function getParkingPaymentInfo(data) {
    return fetch({
        url: 'api/keyTop/getParkingPaymentInfo',
        method: 'POST',
       
        data
    })
}
export function getwebApiBasicConfig(data) {
    console.log(data,'getwebApiBasicConfig');
    return fetch({
        url: '/webApi/encrypt/area/info',
        method: 'POST',
        isEncrypt:true,
        merId:"10002211252",
        data
    })
}
export function getParkingInfo(data) {
    console.log(data,'datainfo');
    
    return fetch({
        url: '/webApi/encrypt/park/info',
        method: 'POST',
        isEncrypt:true,
        merId:"10002211252",
        data
    })
}
